<template>
  <div class="animated fadeIn">
    <h4 class="page-title">MRS</h4>
    <hr >
    <b-row>
      <b-col>
        <b-form @submit.prevent="handleSearch">
          <b-row class="mb-3">
            <b-col sm="3">
              <b-form-group label="License Plate">
                <v-select
                  v-model="searchForm.licensePlate"
                  :options="licensePlates"
                  placeholder="License plate"
                  @search="fetchLicensePlates"
                  @input="handleSearch" />
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group label="Make">
                <b-form-input
                  v-model="searchForm.make"
                  size="sm"
                  placeholder="Make" />
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group label="Model">
                <b-form-input
                  v-model="searchForm.model"
                  size="sm"
                  placeholder="Model" />
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-btn
                :disabled="isSubmitting || !searchForm.licensePlate && !searchForm.make && !searchForm.model"
                size="sm"
                variant="warning"
                type="submit"
                class="mt-4">Search</b-btn>
            </b-col>
            <!-- <b-col sm="3">
              <b-form-group label="Chasis Number">
                <b-form-input
                  v-model="vehicle.chasisNumber"
                  size="sm"
                  disabled
                  placeholder="Chasis Number" />
              </b-form-group>
              <b-form-group label="Engine Number">
                <b-form-input
                  v-model="vehicle.engineNumber"
                  size="sm"
                  disabled
                  placeholder="Engine Number" />
              </b-form-group>
              <b-btn
                :disabled="isSubmitting || !searchForm.licensePlate"
                size="sm"
                variant="warning"
                type="submit">Search</b-btn>
            </b-col>
            <b-col sm="6">
              <div class="border p-3">
                <b-row>
                  <b-col sm="6">
                    <b-form-group label="Next Service Date">
                      <date-picker
                        v-model="nextServiceDate"
                        input-class="form-control form-control-sm"
                        :shortcuts="false"
                        :popup-style="{'top': '0px'}"
                        format="YYYY-MM-DD"
                        width="100%"
                        lang="en" />
                    </b-form-group>
                  </b-col>
                  <b-col sm="6">
                    <b-form-group label="Mileage">
                      <b-form-input v-model="mileage" size="sm" />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-form-group label="Follow Up Remarks">
                  <b-textarea v-model="followupNextService" />
                </b-form-group>
                <b-btn
                  v-if="vehicleFound"
                  :disabled="isSubmitting"
                  variant="primary"
                  size="sm"
                  @click="handleUpdate">
                  Update  
                </b-btn>
              </div>
            </b-col> -->
          </b-row>
        </b-form>
        <hr>
        <b-btn
          v-if="items.length"
          size="sm"
          variant="success"
          class="mb-3"
          @click="handleDownloadAll">
          <i class="fa fa-download" />&nbsp;
          Download all invoice
        </b-btn>
        <div v-for="(item, idx) in items" :key="item.licensePlate" class="mb-3">
          <b-btn
            v-b-toggle="`${idx}-${item.licensePlate}`"
            variant="secondary"
            class="w-50 text-left"
            type="button"
            @click="toggleItem(item.licensePlate)">
            <i :class="{'icon-minus': collapsedItems.includes(item.licensePlate), 'icon-plus': !collapsedItems.includes(item.licensePlate)}" />&nbsp;
            <span class="font-weight-bold">{{ item.licensePlate }}</span> {{ item.makeModel ? `[${item.makeModel}]` : '' }}
          </b-btn>
          <b-collapse :id="`${idx}-${item.licensePlate}`" class="mt-2">
            <b-card body-class="p-3">
              <b-row>
                <b-col sm="4">
                  <InlineLabel
                    :value="item.chasisNumber"
                    label="Chasis Number" />
                </b-col>
                <b-col sm="4">
                  <InlineLabel
                    :value="item.engineNumber"
                    label="Engine Number" />
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col sm="3">
                  <b-form-group label="Next Service Date">
                    <date-picker
                      v-model="item.nextServiceDate"
                      :shortcuts="false"
                      :popup-style="{'top': '0px'}"
                      input-class="form-control form-control-sm"
                      format="YYYY-MM-DD"
                      width="100%"
                      lang="en" />
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label="Mileage">
                    <b-form-input v-model="item.mileage" size="sm" />
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label="Follow Up Remarks">
                    <b-form-input v-model="item.followupNextService" size="sm" />
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label="Key Battery Change Date">
                    <date-picker
                      v-model="item.keyBatteryChangeDate"
                      :shortcuts="false"
                      :popup-style="{'top': '0px'}"
                      input-class="form-control form-control-sm"
                      format="YYYY-MM-DD"
                      width="100%"
                      lang="en" />
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label="Vehicle Battery Change Date">
                    <date-picker
                      v-model="item.vehicleBatteryChangeDate"
                      :shortcuts="false"
                      :popup-style="{'top': '0px'}"
                      input-class="form-control form-control-sm"
                      format="YYYY-MM-DD"
                      width="100%"
                      lang="en" />
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-btn
                    :disabled="isSubmitting"
                    variant="primary"
                    size="sm"
                    class="mt-4"
                    @click="handleUpdate(item)">
                    Update  
                  </b-btn>
                </b-col>
              </b-row>
              <div v-if="vehicleFound" class="d-flex justify-content-between mb-3">
                <b-btn variant="success" size="sm" @click="handleModalVisibility(item)">
                  <i class="fa fa-plus" />&nbsp;
                  New record
                </b-btn>
                <div>
                  <b-btn variant="success" size="sm" @click="handleDownload(item)">
                    <i class="fa fa-download" />&nbsp;
                    Download
                  </b-btn>
                  <b-btn
                    class="ml-1"
                    size="sm"
                    variant="outline-success"
                    @click="expandAllInvoice(item)">
                    {{ item.isExpandAll ? 'Collapse All' : 'Expand All' }}
                  </b-btn>
                </div>
              </div>
              <b-row class="mt-3">
                <b-col>
                  <b-table-simple v-if="item.vehicleRecordMr && item.vehicleRecordMr.length">
                    <b-thead head-variant="light">
                      <b-th>Invoice No</b-th>
                      <b-th>Date Service</b-th>
                      <b-th>Workshop</b-th>
                      <b-th>Mileage</b-th>
                      <b-th />
                    </b-thead>
                    <b-tbody>
                      <template v-for="invoice in item.vehicleRecordMr">
                        <b-tr
                          :key="invoice.id"
                          class="cursor-pointer">
                          <b-td @click="toggleInvoice(invoice)">{{ invoice.invoiceNo }}</b-td>
                          <b-td @click="toggleInvoice(invoice)">{{ invoice.dateService | date('YYYY-MM-DD') }}</b-td>
                          <b-td @click="toggleInvoice(invoice)">{{ invoice.workShop }}</b-td>
                          <b-td @click="toggleInvoice(invoice)">{{ invoice.mileage }}</b-td>
                          <b-td>
                            <b-btn
                              v-b-tooltip.hover
                              size="sm"
                              variant="success"
                              title="Edit invoice"
                              class="ml-2"
                              @click="editInvoice(item, invoice)">
                              <i class="fa fa-pencil" />
                            </b-btn>
                            <b-btn
                              v-b-tooltip.hover
                              size="sm"
                              variant="danger"
                              title="Delete invoice"
                              class="ml-2"
                              @click="deleteInvoice(invoice)">
                              <i class="fa fa-close" />
                            </b-btn>
                          </b-td>
                        </b-tr>
                        <b-tr
                          v-if="collapsedInvoice.includes(invoice.id)"
                          :key="`${invoice.id}-items`">
                          <b-td colspan="4">
                            <b-table-simple small table-variant="secondary">
                              <b-thead head-variant="dark">
                                <b-th>Job Description</b-th>
                                <b-th>Work Carried Out</b-th>
                                <b-th>Quantity</b-th>
                                <b-th>Unit Price</b-th>
                                <b-th>Price</b-th>
                              </b-thead>
                              <b-tbody>
                                <b-tr
                                  v-for="(invoiceItem, idx) in invoice.items"
                                  :key="idx">
                                  <b-td>{{ invoiceItem.jobDesc }}</b-td>
                                  <b-td>{{ invoiceItem.workCarriedOut }}</b-td>
                                  <b-td>{{ invoiceItem.quantity }}</b-td>
                                  <b-td>{{ invoiceItem.unitPrice }}</b-td>
                                  <b-td>{{ invoiceItem.price }}</b-td>
                                </b-tr>
                              </b-tbody>
                            </b-table-simple>
                          </b-td>
                        </b-tr>
                      </template>
                    </b-tbody>
                  </b-table-simple>
                </b-col>
              </b-row>
            </b-card>
          </b-collapse>
        </div>
        <!-- <div v-if="vehicleFound" class="d-flex justify-content-between mb-3">
          <b-btn variant="success" size="sm" @click="handleModalVisibility">
            <i class="fa fa-plus" />&nbsp;
            New record
          </b-btn>
          <b-btn variant="success" size="sm" @click="handleDownload">
            <i class="fa fa-download" />&nbsp;
            Download
          </b-btn>
        </div>
        <div 
          v-if="isFetching" 
          style="margin: 0 auto; width: 10px;">
          <div class="loader-dark-blue medium mb-5 mt-5"/>
        </div>
        <b-table
          v-if="maintenanceList.length"
          :items="maintenanceList"
          :fields="fields"
          fixed
          hover
          striped>
          <template v-slot:cell(dateService)="row">
            {{ row.item.dateService | date('YYYY-MM-DD') }}
          </template>
          <template v-slot:cell(action)="row">
            <b-btn
              v-b-tooltip.hover
              size="sm"
              variant="info"
              title="View invoice"
              @click="viewInvoice(row.item)">
              <i class="fa fa-eye" />
            </b-btn>
            <b-btn
              v-b-tooltip.hover
              size="sm"
              variant="danger"
              title="Delete invoice"
              class="ml-2"
              @click="deleteInvoice(row.item)">
              <i class="fa fa-close" />
            </b-btn>
          </template>
        </b-table> -->
      </b-col>
    </b-row>

    <!-- View modal -->
    <MRSModal 
      v-if="addModalVisibility"
      :is-submitting="isSubmitting"
      :done-submitting="doneSubmitting"
      :selected-invoice="selectedInvoice"
      :is-edit="isEditInvoice"
      modal-id="mrs-modal"
      @added="handleAddRecord" />
    
    <b-modal
      id="invoice-modal"
      v-if="selectedInvoice"
      :scrollable="true"
      title="Invoice Details"
      header-bg-variant="success"
      hide-footer
      size="md">
      <b-row>
        <b-col sm="6">
          <b-form-group label="Invoice No">
            <span class="font-weight-bold">{{ selectedInvoice.invoiceNo }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Date Service">
            <span class="font-weight-bold">{{ selectedInvoice.dateService | date('YYYY-MM-DD') }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Workshop">
            <span class="font-weight-bold">{{ selectedInvoice.workShop }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Mileage">
            <span class="font-weight-bold">{{ selectedInvoice.mileage }}</span>
          </b-form-group>
        </b-col>
      </b-row>
      <b-table-simple>
        <b-thead head-variant="light">
          <b-th>Job Description</b-th>
          <b-th>Work Carried Out</b-th>
          <b-th>Price</b-th>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(item, idx) in selectedInvoice.items" :key="idx">
            <b-td>{{ item.jobDesc }}</b-td>
            <b-td>{{ item.workCarriedOut }}</b-td>
            <b-td>{{ item.price }}</b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </b-modal>
  </div>
</template>
<script>
import debounce from 'lodash/debounce'
import { toastr } from '@/services'
import transformJson from '@/utils/transformJson'
import { mapState } from 'vuex'
import DatePicker from 'vue2-datepicker'
import vSelect from 'vue-select'
import MRSModal from './MRSModal'
import InlineLabel from '@/components/InlineLabel'

export default {
  name: 'MRS',
  components: {
    MRSModal,
    DatePicker,
    InlineLabel,
    vSelect
  },
  data () {
    return {
      addModalVisibility: false,
      selectedItem: undefined,
      currentPage: 1,
      searchForm: {
        licensePlate: undefined,
        make: undefined,
        model: undefined
      },
      make: undefined,
      model: undefined,
      isDownloading: false,
      vehicleForm: {},
      fields: [
        'dateService',
        'invoiceNo',
        'workShop',
        'mileage',
        'action'
      ],
      items: [],
      collapsedItems: [],
      collapsedInvoice: [],
      selectedInvoice: {},
      isFetching: false,
      isSubmitting: false,
      doneSubmitting: false,
      visible: false,
      isExpandAll: false,
      isEditInvoice: false
    }
  },
  computed: {
    ...mapState('mrs', [
      'vehicle',
      'licensePlates'
    ]),
    maintenanceList() {
      if (!this.vehicle.vehicleRecordMr) {
        return []
      }
      return this.vehicle.vehicleRecordMr 
    },
    nextServiceDate: {
      get() {
        return this.vehicle.nextServiceDate
      },
      set(val) {
        this.$store.commit('mrs/SET_DATA', { vehicle: {...this.vehicle, nextServiceDate: this.$options.filters.date(val, 'YYYY-MM-DD')} })
      }
    },
    followupNextService: {
      get() {
        return this.vehicle.followupNextService
      },
      set(val) {
        this.$store.commit('mrs/SET_DATA', { vehicle: {...this.vehicle, followupNextService: val} })
      }
    },
    mileage: {
      get () {
        return this.vehicle.mileage
      },
      set (val) {
        this.$store.commit('mrs/SET_DATA', { vehicle: {...this.vehicle, mileage: val} })
      }
    },
    vehicleFound() {
      return this.items.length > 0
    },
  },
  beforeDestroy() {
    this.$store.commit('mrs/RESET_FORM')
  },
  methods: {
    fetchLicensePlates: debounce(function (search) {
      if (!search) return
      try {
        this.$store.dispatch('mrs/fetchLicensePlates', { query: search })
      } catch (err) {
        toastr.serverError()
      }
    }, 300),
    async handleSearch () {
      try {
        this.collapseItems = {}
        this.doneSubmitting = false
        if (!this.searchForm.licensePlate && this.searchForm.make && this.searchForm.model) {
          this.$store.commit('mrs/RESET_FORM')
          return
        }
        this.$store.commit('mrs/RESET_FORM')
        this.isSubmitting = true
        const resp = await this.$store.dispatch('mrs/fetchVehicle', this.searchForm)
        this.items = transformJson(resp.data.msgContent.data, true).map((item) => ({...item, isExpandAll: false }))
        this.isSubmitting = false
        if (!this.items.length) {
          toastr.error('No vehicle found.')
        }
      } catch (err) {
        toastr.serverError()
      }
    },
    toggleItem(licensePlate) {
      const idx = this.collapsedItems.indexOf(licensePlate)
      if (idx > -1) {
        this.collapsedItems.splice(idx, 1)
      } else {
        this.collapsedItems.push(licensePlate)
      }
    },
    async handleUpdate(item) {
      try {
        this.isSubmitting = true
        const { licensePlate, nextServiceDate, followupNextService, mileage, keyBatteryChangeDate, vehicleBatteryChangeDate } = item
        const payload = {
          vehicleNumber: licensePlate,
          nextServiceDate,
          followupNextService,
          mileage,
          keyBatteryChangeDate,
          vehicleBatteryChangeDate,
          vehicleRecordMR: []
        }
        await this.$store.dispatch('mrs/updateVehicle', [payload])
        this.isSubmitting = false
        toastr.success(false, 2000)
        this.handleSearch()
      } catch (err) {
        toastr.serverError()
      }
    },
    handleReset () {
      this.licensePlate = undefined
      this.make = undefined
      this.model = undefined
    },
    async handleAddRecord (item) {
      try {
        this.doneSubmitting = false
        this.isSubmitting = true
        const vehicleRecordTmp = this.vehicle.vehicleRecordMr ? [...this.vehicle.vehicleRecordMr] : []
        vehicleRecordTmp.push(item)
        const temp = {
          vehicle: {
            ...this.selectedItem,
            vehicleRecordMr: vehicleRecordTmp
          }
        }
        // update UI
        // this.$store.commit('mrs/SET_DATA', temp)
        // update to server
        // eslint-disable-next-line no-unused-vars
        const { chasisNumber, makeModel, engineNumber, vehicleRecordMr, licensePlate, ...rest } = temp.vehicle
        const payload = {
          ...rest,
          vehicleRecordMR: [item],
          vehicleNumber: licensePlate,
        }
        await this.$store.dispatch('mrs/updateVehicle', [payload])
        this.isSubmitting = false
        this.doneSubmitting = true
        setTimeout(() => {
          this.$bvModal.hide('mrs-modal')
        }, 100)
        await this.$store.dispatch('mrs/fetchVehicle', this.searchForm)
        const resp = await this.$store.dispatch('mrs/fetchVehicle', this.searchForm)
        this.items = transformJson(resp.data.msgContent.data, true)
        toastr.success(false, 2000)
      } catch (err) {
        console.log(err)
        toastr.serverError()
      }
    },
    handleModalVisibility (selectedItem, selectedInvoice) {
      this.selectedItem = selectedItem
      this.selectedInvoice = selectedInvoice
      this.addModalVisibility = true
      setTimeout(() => {
        this.$bvModal.show('mrs-modal')
      }, 100)
    },
    viewInvoice (item) {
      this.selectedInvoice = item
      this.$bvModal.show('invoice-modal')
    },
    async refetchData () {
      try {
        await this.$store.dispatch('mrs/fetchVehicle', this.searchForm)
        const resp = await this.$store.dispatch('mrs/fetchVehicle', this.searchForm)
        this.items = transformJson(resp.data.msgContent.data, true)
      } catch (err) {
        console.log(err)
        toastr.serverError()
      }
    },
    async deleteInvoice (item) {
      try {
        await this.$store.dispatch('mrs/deleteInvoice', item)
        toastr.info('Invoice successfully deleted', false, 1000)
        await this.refetchData()
      } catch (err) {
        toastr.serverError()
      }
    },
    async editInvoice (record, invoiceItem) {
      try {
        this.isEditInvoice = true
        this.handleModalVisibility(record, invoiceItem)
      } catch (err) {
        console.log(err)
      }
    },
    handleDownload (selectedItem) {
      const replacer = (key, value) => value === null ? '' : value // specify how you want to 
      const arr = selectedItem.vehicleRecordMr.map((item) => {
        // eslint-disable-next-line no-unused-vars
        const { items, id, ...rest } = item
        return item.items.map((o) => ({
          licensePlate: selectedItem.licensePlate,
          makeModel: selectedItem.makeModel,
          chasisNumber: selectedItem.chasisNumber,
          engineNumber: selectedItem.engineNumber,
          nextServiceDate: this.$options.filters.date(selectedItem.nextServiceDate, 'YYYY-MM-DD'),
          followupNextService: selectedItem.followupNextService,
          ...({...rest, dateService: this.$options.filters.date(item.dateService, 'YYYY-MM-DD')}),
          ...o,
        }))
      }).flat()
      const headers = Object.keys(arr[0])
      let csvData = arr.map(row => headers.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
      csvData.unshift(headers.join(','))
      csvData = csvData.join('\r\n')
      const filename = `MRS_${this.searchForm.licensePlate}_${this.$options.filters.date(new Date(), 'YYYY-MM-DD')}.csv`
      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' })
      if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, filename)
      } else {
        const link = document.createElement('a')
        if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          const url = URL.createObjectURL(blob)
          link.setAttribute('href', url)
          link.setAttribute('download', filename)
          link.style.visibility = 'hidden'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }
    },
    handleDownloadAll () {
      const replacer = (key, value) => value === null ? '' : value // specify how you want to 
      let arr = []
      this.items.forEach((obj) => {
        if (obj.vehicleRecordMr.length) {
          obj.vehicleRecordMr.forEach((item) => {
            // eslint-disable-next-line no-unused-vars
            const { items, id, ...rest } = item
            let tmp = items.map((o) => ({
              licensePlate: obj.licensePlate,
              makeModel: obj.makeModel,
              chasisNumber: obj.chasisNumber,
              engineNumber: obj.engineNumber,
              nextServiceDate: this.$options.filters.date(obj.nextServiceDate, 'YYYY-MM-DD'),
              followupNextService: obj.followupNextService,
              ...({...rest, dateService: this.$options.filters.date(item.dateService, 'YYYY-MM-DD')}),
              ...o,
            }))
            arr = [...arr, ...tmp]
          })
        }
      })
      arr = arr.flat()
      const headers = Object.keys(arr[0])
      let csvData = arr.map(row => headers.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
      csvData.unshift(headers.join(','))
      csvData = csvData.join('\r\n')
      const filename = `MRS_ALL_INVOICE_${this.$options.filters.date(new Date(), 'YYYY-MM-DD')}.csv`
      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' })
      if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, filename)
      } else {
        const link = document.createElement('a')
        if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          const url = URL.createObjectURL(blob)
          link.setAttribute('href', url)
          link.setAttribute('download', filename)
          link.style.visibility = 'hidden'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }
    },
    toggleInvoice(invoice) {
      const idx = this.collapsedInvoice.indexOf(invoice.id)
      if (idx > -1) {
        this.collapsedInvoice.splice(idx, 1)
      } else {
        this.collapsedInvoice.push(invoice.id)
      }
    },
    expandAllInvoice (item) {
      item.isExpandAll = !item.isExpandAll
      if (item.isExpandAll) {
        item.vehicleRecordMr.forEach((invoice) => {
          this.collapsedInvoice.push(invoice.id)
        })
      } else {
        item.vehicleRecordMr.forEach((invoice) => {
          this.collapsedInvoice = this.collapsedInvoice.filter(o => o !== invoice.id)
        })
      }
    }
  }
}
</script>
<style lang="scss">
@import 'vue-select/src/scss/vue-select.scss';
</style>